import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import HttpApiTemplate from './HttpApiTemplate'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class HttpApiComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.HTTP_API)

    this.data.component = HttpApiTemplate
    this.socket = config.sockets ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.HTTP_API
    this.setConnection()

    const httpApiInput = new Rete.Input(CONST_SOCKET.HTTP_API_INPUT, lang.http_api_socket_input_reply, this.socket.httpApiInput, false)
    const httpApiOutput = new Rete.Output(CONST_SOCKET.HTTP_API_OUTPUT, lang.http_api_socket_output_next, this.socket.httpApiOutput, false)

    return node
      .addInput(httpApiInput)
      .addOutput(httpApiOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {

  }

  setConnection() {
    // http api may be connected to:
    this.socket.httpApiOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.httpApiOutput.combineWith(this.socket.openaiInput)
    this.socket.httpApiOutput.combineWith(this.socket.carouselInput)
    this.socket.httpApiOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.httpApiOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.httpApiOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.httpApiOutput.combineWith(this.socket.videoInput)
      this.socket.httpApiOutput.combineWith(this.socket.audioInput)
      this.socket.httpApiOutput.combineWith(this.socket.fileInput)
      // this.socket.httpApiOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.httpApiOutput.combineWith(this.socket.rcnInput)

    this.socket.httpApiOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.httpApiOutput.combineWith(this.socket.ecommerceInput)
    this.socket.httpApiOutput.combineWith(this.socket.componentListInput)

    // if(this.http_api_module)
    // {
    //   this.socket.httpApiOutput.combineWith(this.socket.httpApiInput)
    // }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.httpApiOutput.combineWith(this.socket.userInputFlowInput)
    }

  }
}